// extracted by mini-css-extract-plugin
export default {"scroll-container":"qroYy-sAqB3pu+uAwvLqMA=="};